import React from 'react';
import { theme } from '../../styles/theme';

const SectionTitle = ({
  children,
  size = 'lg',
  align = 'center',
  withDecorative = true,
  style = {},
  ...props
}) => {
  const sizeStyles = {
    sm: {
      fontSize: theme.typography.fontSize.xl,
      marginBottom: theme.spacing.sm,
    },
    md: {
      fontSize: theme.typography.fontSize['2xl'],
      marginBottom: theme.spacing.md,
    },
    lg: {
      fontSize: theme.typography.fontSize['3xl'],
      marginBottom: theme.spacing.lg,
    },
    xl: {
      fontSize: theme.typography.fontSize['4xl'],
      marginBottom: theme.spacing.lg,
    },
  };

  const baseStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.primary,
    textAlign: align,
    lineHeight: theme.typography.lineHeight.tight,
    letterSpacing: '0.05em',
    ...sizeStyles[size],
    ...style,
  };

  const containerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: align,
    gap: theme.spacing.md,
    marginBottom: sizeStyles[size].marginBottom,
  };

  const lineStyles = {
    flex: align === 'center' ? '1' : '0 0 60px',
    maxWidth: align === 'center' ? '120px' : '60px',
    height: '2px',
    background: `linear-gradient(to ${align === 'left' ? 'right' : align === 'right' ? 'left' : 'right'}, ${theme.colors.primary}, ${theme.colors.accent})`,
  };

  if (withDecorative && align === 'center') {
    return (
      <div style={containerStyles}>
        <div style={lineStyles} />
        <h2 style={{ ...baseStyles, marginBottom: 0 }} {...props}>
          {children}
        </h2>
        <div style={lineStyles} />
      </div>
    );
  }

  return (
    <div style={{ textAlign: align }}>
      <h2 style={baseStyles} {...props}>
        {children}
      </h2>
      {withDecorative && (
        <div style={{
          ...lineStyles,
          marginTop: theme.spacing.sm,
          marginLeft: align === 'center' ? 'auto' : '0',
          marginRight: align === 'center' ? 'auto' : '0',
        }} />
      )}
    </div>
  );
};

export default SectionTitle;

